import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  getFeedbackStart,
  postFeedbackStart,
} from "../../redux/feedback/reducer";
import { feedbackList, feedbackLoading } from "../../redux/feedback/selectors";
import usePaginationWrapper from "../../hooks/general/usePaginationWrapper";
const useFeedbackGet = ({ questionId, resolved, issueType }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(feedbackLoading);
  const feedbacks = useSelector(feedbackList);

  const [fetch, setFetch] = useState(0);
  const refetch = () => setFetch((prev) => prev + 1);
  const {
    limit,
    offset,
    setOffset,
    setLimit,
    totalElements,
    totalPages,
    numberOfElements,
    setPageable,
    page,
    setPage,
    pageOptions,
    searchText,
    debouncedSearchText,
    setSearchText,
  } = usePaginationWrapper({ defaultLimit: 10 });

  const fetchFeedback = useCallback(() => {
    dispatch(
      getFeedbackStart({
        questionId,
        resolved,
        issueType,
        keyword: debouncedSearchText,
        size: limit,
        page: page - 1,
      })
    );
  }, [
    dispatch,
    questionId,
    resolved,
    issueType,
    page,
    limit,
    debouncedSearchText,
  ]);

  const postFeedback = useCallback(
    (data) => {
      dispatch(postFeedbackStart(data));
    },
    [dispatch]
  );

  useEffect(() => {
    if (feedbacks) {
      setPageable({
        total_elements: feedbacks?.count,
        total_pages: feedbacks?.pages,
        number_of_elements: feedbacks?.items?.length,
      });
    }
  }, [feedbacks, setPageable, fetch, resolved, debouncedSearchText]);

  useEffect(() => {
    fetchFeedback();
  }, [fetchFeedback, fetch]);

  return {
    feedbacks,
    isLoading,
    refetch,
    limit,
    offset,
    setOffset,
    setLimit,
    totalElements,
    totalPages,
    numberOfElements,
    setPageable,
    page,
    setPage,
    pageOptions,
    searchText,
    debouncedSearchText,
    setSearchText,
    postFeedback,
  };
};

export default useFeedbackGet;
